export const SuggestionsContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const SuggestionsDesign = {
  backgroundColor: "white",
  color: "gray",
  padding: "8px 16px",
  borderRadius: "12px",
  maxWidth: "70%",
  width: "fit-content",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  border: "1px solid gray",
  transition: "color 0.3s, border-color 0.3s",
  mb: 1,
  "&:hover": {
    color: "blue",
    borderColor: "blue",
    cursor: "pointer",
  },
};
